module.exports = __webpack_public_path__ + "img/2400f.899d5dfb.png";